import { useLocalObservable } from 'mobx-react-lite';

import { ActiveSidebarView } from '../Content.types';

export interface IActiveSidebarViewPresenter {
  activeSidebarView: ActiveSidebarView;
  openInfoViewSidebar(): void;
  openCreateViewSidebar(): void;
  openEditViewSidebar(): void;
  hideSidebar(): void;
}

export const useActiveSidebarViewPresenter = (): IActiveSidebarViewPresenter => {
  const presenter = useLocalObservable<IActiveSidebarViewPresenter>(() => ({
    activeSidebarView: ActiveSidebarView.Empty,

    hideSidebar(): void {
      presenter.activeSidebarView = ActiveSidebarView.Empty;
    },

    openInfoViewSidebar(): void {
      presenter.activeSidebarView = ActiveSidebarView.Info;
    },

    openCreateViewSidebar(): void {
      presenter.activeSidebarView = ActiveSidebarView.Create;
    },

    openEditViewSidebar(): void {
      presenter.activeSidebarView = ActiveSidebarView.Edit;
    },
  }));

  return presenter;
};
